import toast from "react-hot-toast";
import {
  IoAlertCircleOutline,
  IoCheckmarkCircleOutline,
} from "react-icons/io5";

const Success = (message) => {
  return toast.success(message, {
    duration: 3500,
    className: "text-sm text-white bg-green-400",
    icon: <IoCheckmarkCircleOutline className="text-xl" />,
  });
};

const Error = (message) => {
  return toast.error(message, {
    duration: 4000,
    className: "text-sm text-white bg-red-400",
    icon: <IoAlertCircleOutline className="text-xl" />,
  });
};

const Toaster = {
  Success,
  Error,
};

export default Toaster;
